/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityServiceAreaUploadUrlResponse
 */
export interface CreateFacilityServiceAreaUploadUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityServiceAreaUploadUrlResponse
     */
    signed_url: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFacilityServiceAreaUploadUrlResponse
     */
    s3_key: string;
}

/**
 * Check if a given object implements the CreateFacilityServiceAreaUploadUrlResponse interface.
 */
export function instanceOfCreateFacilityServiceAreaUploadUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signed_url" in value;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function CreateFacilityServiceAreaUploadUrlResponseFromJSON(json: any): CreateFacilityServiceAreaUploadUrlResponse {
    return CreateFacilityServiceAreaUploadUrlResponseFromJSONTyped(json, false);
}

export function CreateFacilityServiceAreaUploadUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceAreaUploadUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signed_url': json['signed_url'],
        's3_key': json['s3_key'],
    };
}

export function CreateFacilityServiceAreaUploadUrlResponseToJSON(value?: CreateFacilityServiceAreaUploadUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signed_url': value.signed_url,
        's3_key': value.s3_key,
    };
}

